
import filters from "@/mixins/filters";

export default {
	mixins: [filters],
	props: {
		offer: Object
	},
}
